<template>
  <div v-if="childList" class="p-the-header-navi-child-on-admin__wrapper">
    <div ref="targetElement" class="p-the-header-navi-child-on-admin">
      <ul
        ref="targetContentsElement"
        :class="{ 'p-the-header-navi-child-on-admin__active-list': isOpen }"
        class="p-the-header-navi-child-on-admin__list"
      >
        <li
          v-for="({ label, url, hasNotification }, key) in childList"
          :key="key"
          class="p-the-header-navi-child-on-admin__list__item"
        >
          <a
            v-touch:tap
            class="p-the-header-navi-child-on-admin__link"
            :href="url"
            :style="{ color: hoverColor[isHover(key)] }"
            @mouseover="mouseover(key)"
            @mouseleave="mouseleave"
          >
            <span class="p-the-header-navi-child-on-admin__link__text">{{
              label
            }}</span>

            <span class="p-the-header-navi-child-on-admin__link__notification">
              <TextLabelNewArrivalCount
                :count="getNotificationCount(hasNotification)"/></span
          ></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
// import * as dropdownAnimation from '../../../../assets/js/mixins/dropdownAnimation.js';
import commons from "@/common/store/modules/commons";
@Options({
  props: {
    childList: { type: [Array, Boolean], default: false },
    shown: { type: Boolean, default: false },
    thanksPointCount: { type: Number, default: 0 }
  },
  components: {
    TextLabelNewArrivalCount
  },
  watch: {
    shown(newValue: any, oldValue: string) {
      this.isOpen = newValue;
    }
  }
})
export default class TheHeaderNaviChildOnAdmin extends Vue {
  childList!: boolean;
  shown!: boolean;
  thanksPointCount!: number;

  get colorCode() {
    return commons?.colorCode;
  }

  // mixins: any = [dropdownAnimation];
  isOpen: any = false;
  hoverColor: any = {
    true: this.colorCode,
    false: "#616161"
  };
  currentHoverElementKey = -1;
  adminNotificationCount: any;

  isHover(currentKey: any) {
    return this.currentHoverElementKey === currentKey;
  }

  created() {
    this.isOpen = this.shown;
  }

  mounted() {
    this.initCustomColor();
  }

  initCustomColor() {
    const { colorCode } = this;
    this.hoverColor.true = colorCode;
  }

  mouseover(elementKey: any) {
    this.currentHoverElementKey = elementKey;
  }

  mouseleave() {
    this.currentHoverElementKey = -1;
  }
  getNotificationCount(hasNotification: any) {
    if (hasNotification) {
      const thankspointCount = this.thanksPointCount;
      return thankspointCount > 9 ? "..." : thankspointCount;
    } else {
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-header-navi-child-on-admin {
  overflow: hidden;
  &__item {
  }

  &__list {
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    height: 0;
    opacity: 0;
  }

  &__active-list {
    height: max-content;
    opacity: 1;
  }

  &__link {
    width: 100%;
    display: block;
    padding: rem(9) rem(8) rem(9) rem(44);
    font-size: rem(14);
    line-height: 1.6;

    &__text {
      display: inline-block;
      vertical-align: middle;
    }

    &__notification {
      display: inline-block;
      vertical-align: middle;
      margin-left: rem(8);
    }

    &__wrapper {
      -webkit-transiiton: all 0.4s;
    }

    &.tap {
      transition: all $transition-sec--fast ease-in;
    }
  }
}
</style>
